import gsap from 'gsap';


export default (scroller) => {

  let header = document.getElementById('header');
  let searchBtn = document.getElementById('header__search-open');
  let closeSearchBtn = document.getElementById('header__search-close');
  let menuBtn = document.getElementById('header__menu-btn');

  let menuLinks = document.querySelectorAll('.menu__link');
  let portalLinks = document.querySelectorAll('.menu__link');
  let menuBottomLinks = document.querySelectorAll('.menu__bottom-link');
  let menuBottom = document.querySelector('.menu__bottom');
  let headerLogoLink = document.querySelector('.header__logo-link');

  let menuLinksHasChildren = document.querySelectorAll('.menu__link.has-children');
  let menuLinksNoChildren = document.querySelectorAll('.menu__link:not(.has-children)');


  let menuSecondaryBlock = document.querySelector('.menu__secondary-block');
  let menuSecondary = document.querySelectorAll('.menu__secondary');
  let menuSecondaryLink = document.querySelectorAll('.menu__secondary-link');


  let menuSecondaryBeforeButton = document.querySelectorAll('.menu__secondary-before-button');
  let menuSecondaryCloseButton = document.querySelectorAll('.menu__secondary-close-button');

  const SEARCH__OPEN = 'search-opened';
  const MENU__OPEN = 'menu-opened';
  const BODY__OVERFLOW = 'body-overflow';

  const MENU_ACTIVE = 'menu-active-link';
  const MENU_PASSIVE = 'menu-passive-link';



  const SECONDARY_MENU_OPEN = 'secondary-menu-opened';
  const SECONDARY_MENU_ACTIVE = 'secondary-menu-active';

  if(searchBtn){
    searchBtn.addEventListener('click', () => {
      header.classList.add(SEARCH__OPEN);
    });

    closeSearchBtn.addEventListener('click', () => {
      header.classList.remove(SEARCH__OPEN);
    });
  }

  if(menuBtn){
    menuBtn.addEventListener('click', () => {
      closeMenu();
    });
  }

  function closeMenu(){
    if(!header.classList.contains(MENU__OPEN)) {
      header.classList.add(MENU__OPEN);
      document.body.classList.add(BODY__OVERFLOW);
    } else {
      closeMenuWasOpened();
    }
  }

  function closeMenuWasOpened() {
    header.classList.remove(MENU__OPEN);
    document.body.classList.remove(BODY__OVERFLOW);
    menuSecondaryBlock.classList.remove(SECONDARY_MENU_OPEN);

    menuLinks.forEach(menuLink => {
      menuLink.classList.remove(MENU_ACTIVE);
      menuLink.classList.remove(MENU_PASSIVE);
    });

    menuSecondary.forEach(menuItem => {
      menuItem.classList.remove(SECONDARY_MENU_ACTIVE);
    });
  }

  if(menuLinks){
    menuLinks.forEach(menuLink => {
      menuLink.addEventListener('mouseover', () => {
        menuLinks.forEach(menuLink => {
          menuLink.classList.remove(MENU_ACTIVE);
          menuLink.classList.add(MENU_PASSIVE);
        });

        menuLink.classList.add(MENU_ACTIVE);
        menuLink.classList.remove(MENU_PASSIVE);
      });
    });

    let links = document.querySelectorAll('a');

    document.addEventListener('readystatechange', function() {
      if (document.readyState === "complete") {
        links.forEach(link => {
          link.addEventListener('click', () => {
            closeMenuWasOpened();
  
            setTimeout(() => {
              let headerAnchors = document.querySelector('.header__anchors');
              let headerFilters = document.querySelector('.header__filters');
  
              headerAnchors.classList.remove('anchors-visible');
              headerFilters.classList.remove('filters-visible');
            }, 400);
          });
        });
      }
    });
    
 




  }



  if(menuBottomLinks){
    menuBottomLinks.forEach(menuBottomLink => {
      menuBottomLink.addEventListener('mouseover', () => {
        menuBottomLinks.forEach(menuBottomLink => {
          menuBottomLink.classList.remove(MENU_ACTIVE);
          menuBottomLink.classList.add(MENU_PASSIVE);
        });

        menuBottomLink.classList.add(MENU_ACTIVE);
        menuBottomLink.classList.remove(MENU_PASSIVE);
      });
    });

    menuBottom.addEventListener('mouseout', () => {
      menuBottomLinks.forEach(menuBottomLink => {
        menuBottomLink.classList.remove(MENU_ACTIVE);
        menuBottomLink.classList.remove(MENU_PASSIVE);
      });
    });
  }

  if(menuLinksHasChildren){
    menuLinksHasChildren.forEach(menuLink => {
      menuLink.addEventListener('click', () => {
        let thisMenuAttr = menuLink.getAttribute('data-menu');
        menuSecondaryBlock.classList.add(SECONDARY_MENU_OPEN);

        menuSecondary.forEach(menuItem => {
          menuItem.classList.remove(SECONDARY_MENU_ACTIVE);
          if(thisMenuAttr == menuItem.getAttribute('data-menu')){
            menuItem.classList.add(SECONDARY_MENU_ACTIVE);
          }

          menuItem.addEventListener('mouseout', () => {
            menuSecondaryLink.forEach(menuSecondaryLinkItem => {
              menuSecondaryLinkItem.classList.remove(MENU_ACTIVE);
              menuSecondaryLinkItem.classList.remove(MENU_PASSIVE);
            });
          });
        });
      });
    });
  }

  if(menuLinksNoChildren){
    menuLinksNoChildren.forEach(link => {
      link.addEventListener('click', () => {
				closeMenu();
      });
    });
  }
  if(menuSecondaryLink){
    menuSecondaryLink.forEach(link => {
      link.addEventListener('click', () => {
				closeMenu();
      });
    });
  }
  if(headerLogoLink){
		headerLogoLink.addEventListener('click', () => {
			closeMenuWasOpened();
		});
  }

  if(menuSecondaryLink){
    menuSecondaryLink.forEach(menuSecondaryLinkItem => {
      menuSecondaryLinkItem.addEventListener('mouseover', () => {

        menuSecondaryLink.forEach(menuSecondaryLinkItem => {
          menuSecondaryLinkItem.classList.remove(MENU_ACTIVE);
          menuSecondaryLinkItem.classList.add(MENU_PASSIVE);
        });

        menuSecondaryLinkItem.classList.add(MENU_ACTIVE);
        menuSecondaryLinkItem.classList.remove(MENU_PASSIVE);

      });
    });
  }

  if(menuSecondaryBeforeButton){
    menuSecondaryBeforeButton.forEach((menuSecondaryBeforeButton) => {
      menuSecondaryBeforeButton.addEventListener('click', () => {
        menuSecondaryBlock.classList.remove(SECONDARY_MENU_OPEN);

        menuLinks.forEach(menuLinkItem => {
          menuLinkItem.classList.remove(MENU_PASSIVE);
          menuLinkItem.classList.remove(MENU_ACTIVE);
        });
      });
    });
  }

  if(menuSecondaryCloseButton){
    menuSecondaryCloseButton.forEach((menuSecondaryCloseButton) => {
      menuSecondaryCloseButton.addEventListener('click', () => {
        closeMenu();
      });
    });
  }
      
  if(document.getElementById('portalPage')) {
    let headerAnchors = document.getElementById("anchorsBlock");

  headerAnchors.addEventListener("click", function(){
      // e.preventDefault();
      var target = document.querySelector('.header__anchors');
      if (target.classList.contains('expanded')) {
        target.classList.remove('expanded');
      } else {
        target.classList.add('expanded');
      }

  });

  var acc = document.getElementsByClassName("accordion");
  var plus = document.getElementsByClassName("plus2");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");

      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";

      } 
    });
  }

  }





  


}
